import React from 'react'
import { Link } from 'react-router-dom'
import HeaderSix from '../components/header/HeaderSix'
import FooterSix from '../components/footer/FooterSix'

function PrivacyPolicy() {
    const sections = [
        {
            title: '1. Introduction and Who We Are',
            body: (
                <>
                    TechDigit Solutions operates the website located at <strong>techdigitsolutions.com</strong>. We provide
                    medical billing and revenue cycle management, cybersecurity services, call center and customer support outsourcing,
                    and professional content writing services to clients across the United States.
                    <br />
                    <br />
                    We take privacy seriously. We handle sensitive business information on behalf of our clients every day and we
                    understand better than most what it means when that trust is broken. This policy explains exactly how we handle
                    the personal information collected through this website.
                    <br />
                    <br />
                    If you have questions about anything in this policy, contact us at{' '}
                    <strong>info@techdigitsolutions.com</strong>.
                </>
            ),
        },
        {
            title: '2. Information We Collect',
            body: (
                <>
                    <strong>Information you provide directly.</strong> When you complete our contact form, we collect your first name,
                    last name, email address, phone number, organization name, industry, organization size, location, service interests,
                    and anything you write in the additional information field.
                    <br />
                    <br />
                    <strong>Information collected automatically.</strong> When you visit our website, standard technical information is
                    collected automatically, including your IP address, browser type, device type, pages visited, time spent on pages,
                    and referring website. This information is used solely to understand how visitors use our website and to improve it.
                    It is not linked to your personal identity.
                    <br />
                    <br />
                    <strong>What we do not collect:</strong> We do not collect payment card information, government identification numbers,
                    medical records, or protected health information through this website under any circumstances.
                </>
            ),
        },
        {
            title: '3. How We Use Your Information',
            body: (
                <>
                    We use the information you submit through our contact form for the following purposes only:
                    <br />
                    <br />
                    To respond to your inquiry and arrange the consultation you requested.
                    <br />
                    To provide the services you engage us to deliver under a separate written service agreement.
                    <br />
                    To send you occasional updates and insights if you opted in to receive them. You can unsubscribe at any time by emailing
                    <strong> info@techdigitsolutions.com</strong> or clicking unsubscribe in any email we send.
                    <br />
                    <br />
                    We do not use your information for advertising purposes. We do not build marketing profiles.
                    <br />
                    <br />
                    We do not sell, rent, trade, or share your personal information with third parties for their commercial purposes.
                </>
            ),
        },
        {
            title: '4. How We Store and Protect Your Information',
            body: (
                <>
                    We apply appropriate technical and organizational security measures to protect your personal information against
                    unauthorized access, loss, alteration, or misuse. These measures are consistent with the security standards we implement
                    for our clients.
                    <br />
                    <br />
                    We retain contact form submissions and consultation-related information for up to 24 months from the date of first contact.
                    If a service relationship is established, data retention is governed by the terms of your signed service agreement.
                    After the applicable retention period, your information is securely deleted from our systems.
                </>
            ),
        },
        {
            title: '5. Data Breach Notification',
            body: (
                <>
                    In the event of a data breach affecting personal information collected through this website, TechDigit Solutions will
                    notify affected individuals and relevant regulatory authorities in accordance with applicable federal and state laws.
                    Notification will be provided within the timeframes required by the laws of the applicable jurisdiction, and no later than
                    as required under the most stringent applicable state breach notification law.
                </>
            ),
        },
        {
            title: '6. A Note on Healthcare Information',
            body: (
                <>
                    TechDigit Solutions serves healthcare providers nationwide. We do not collect or process Protected Health Information
                    through this website under any circumstances.
                    <br />
                    <br />
                    If you are a healthcare professional and voluntarily share information about your practice or operations through our contact form
                    or during a consultation, that information is treated with strict confidentiality consistent with our obligations as a
                    healthcare operations partner.
                    <br />
                    <br />
                    Any Protected Health Information shared in the course of a formal service engagement is handled exclusively under a separately
                    executed Business Associate Agreement as required by applicable healthcare privacy regulations. No healthcare-specific service
                    engagement begins without this agreement in place.
                </>
            ),
        },
        {
            title: '7. Cookies and Tracking Technologies',
            body: (
                <>
                    Our website uses cookies and similar tracking technologies to understand how visitors use the site and to improve the experience.
                    We use only the following categories of cookies:
                    <br />
                    <br />
                    <strong>Strictly Necessary Cookies.</strong> Required for the website to function. These cannot be disabled.
                    <br />
                    <br />
                    <strong>Analytics Cookies:</strong> Help us understand how visitors interact with the website by collecting and reporting information anonymously.
                    No personally identifiable information is collected through analytics cookies.
                    <br />
                    <br />
                    We do not use advertising cookies, marketing cookies, or any tracking technology that follows you across other websites or builds advertising profiles
                    based on your browsing behavior.
                    <br />
                    <br />
                    You can instruct your browser to refuse all cookies or notify you when a cookie is being sent. If you disable cookies, some parts of the website may
                    not function as intended.
                </>
            ),
        },
        {
            title: '8. Third Party Links',
            body: (
                <>
                    This website may contain links to third-party websites for reference or convenience. Once you leave techdigitsolutions.com, this Privacy Policy
                    no longer applies.
                    <br />
                    <br />
                    TechDigit Solutions does not endorse, control, or accept responsibility for the content or privacy practices of any third-party website.
                    Visiting linked websites is at your own risk and we encourage you to read their privacy policies independently.
                </>
            ),
        },
        {
            title: '9. California Residents — Your CCPA and CPRA Rights',
            body: (
                <>
                    If you are a California resident, you have the following rights under the California Consumer Privacy Act, as amended by the California Privacy Rights Act:
                    <br />
                    <br />
                    <strong>The right to know.</strong> You may request disclosure of the categories and specific pieces of personal information we have collected about you,
                    the categories of sources from which it was collected, the business purpose for collecting it, and the categories of third parties with whom it is shared.
                    <br />
                    <br />
                    <strong>Categories of personal information we collect:</strong> Identifiers such as name, email address, phone number, and IP address.
                    Commercial information, such as services requested. Internet or network activity, such as pages visited.
                    <br />
                    <br />
                    <strong>Categories of sources:</strong> Directly from you through our contact form and website interactions.
                    Business purpose: To respond to inquiries, arrange consultations, and provide requested services.
                    <br />
                    <br />
                    <strong>Third-party sharing:</strong> We do not sell or share personal information with third parties for commercial purposes.
                    <br />
                    <br />
                    <strong>The right to delete.</strong> You may request that we delete personal information we have collected about you, subject to certain legal exceptions.
                    <br />
                    <br />
                    <strong>The right to correct.</strong> You may request that we correct inaccurate personal information we hold about you.
                    <br />
                    <br />
                    <strong>The right to opt out.</strong> We do not sell or share personal information. No opt-out mechanism for the sale or sharing of data is required
                    because this activity does not occur.
                    <br />
                    <br />
                    <strong>The right to non-discrimination.</strong> We will not discriminate against you for exercising any of your privacy rights.
                    <br />
                    <br />
                    To exercise any of these rights, contact us at <strong>info@techdigitsolutions.com</strong>. We will respond within 45 days. We may extend this period by
                    an additional 45 days, where reasonably necessary and will notify you of any extension within the first 45-day period.
                </>
            ),
        },
        {
            title: '10. GDPR Rights for European Users',
            body: (
                <>
                    If you are located in the European Union or European Economic Area, you have the following rights under the General Data Protection Regulation:
                    <br />
                    <br />
                    <strong>The right to access.</strong> You may request a copy of the personal information we hold about you at no charge for standard requests.
                    <br />
                    <br />
                    <strong>The right to rectification.</strong> You may request correction of inaccurate or incomplete personal information.
                    <br />
                    <br />
                    <strong>The right to erasure.</strong> You may request deletion of your personal information where it is no longer necessary for the purpose it was collected.
                    <br />
                    <br />
                    <strong>The right to restrict processing.</strong> You may request that we limit how we use your personal information under certain conditions.
                    <br />
                    <br />
                    <strong>The right to data portability.</strong> You may request that we transfer your personal information to you or another organization in a structured,
                    commonly used format.
                    <br />
                    <br />
                    <strong>The right to object.</strong> You may object to our processing of your personal information where we rely on legitimate interests as the legal basis for processing.
                    <br />
                    <br />
                    Our legal basis for processing personal information submitted through our contact form is your consent given at the time of submission and our legitimate interest in responding
                    to business inquiries.
                    <br />
                    <br />
                    To exercise any GDPR rights, contact us at <strong>info@techdigitsolutions.com</strong>. We will respond within 30 days.
                </>
            ),
        },
        {
            title: "11. Children's Privacy",
            body: (
                <>
                    This website and our services are intended for business professionals. We do not knowingly collect personal information from individuals under the age of 16.
                    If you believe someone under 16 has submitted personal information through our website, please contact us immediately at <strong>info@techdigitsolutions.com</strong> and we will delete it promptly.
                </>
            ),
        },
        {
            title: '12. Changes to This Privacy Policy',
            body: (
                <>
                    We review and update this Privacy Policy periodically to reflect changes in our practices, services or applicable law. When we make changes, we will update the date at the top of this page.
                    We encourage you to review this page periodically.
                    <br />
                    <br />
                    Continued use of this website after any update constitutes your acceptance of the revised policy. For material changes, we will make reasonable efforts to notify users directly where we hold contact information.
                </>
            ),
        },
        {
            title: '13. Governing Law and Jurisdiction',
            body: (
                <>
                    This Privacy Policy is governed by the laws of the state in which TechDigit Solutions is registered and primarily operates, without regard to conflict of law principles.
                    Any disputes arising in connection with this Privacy Policy shall be subject to the exclusive jurisdiction of the courts of that state.
                </>
            ),
        },
        {
            title: '14. Designated Privacy Contact',
            body: (
                <>
                    All privacy-related inquiries, requests, and concerns should be directed to our Privacy Officer. <br />
                    <strong>info@techdigitsolutions.com</strong> (Mon–Fri 8 AM–6 PM EST).
                    <br />
                    <br />
                    We respond to all privacy-related requests within the timeframes specified in the applicable sections of this policy and no later than 45 days from receipt of any request.
                </>
            ),
        },
    ]

    return (
        <div className="index-six legal-page privacy-page">
            <style>
                {`
                .privacy-page .rts-section-gap {
                    padding: 120px 60px!important;
                }
                `}
            </style>
            <HeaderSix />
            <main>
                <div className="about-page-breadcrumb">
                    <div className="container">
                        <h1 className="about-page-breadcrumb__title">Privacy Policy</h1>
                    </div>
                </div>

                <section className="td-section rts-section-gap">
                    <div className="container-fluid">
                        <p className="disc mt-3">
                            What we collect, why we collect it, how we protect it, and what rights you have over it — explained plainly.
                        </p>
                        <p className="disc">
                            <strong>Last Updated:</strong> March 2025
                        </p>

                        <div className="td-legal-page__panel">
                            {sections.map((s) => (
                                <div key={s.title} className="td-legal-page__section">
                                    <h3 className="td-legal-page__section-title">{s.title}</h3>
                                    <p className="td-legal-page__section-body">{s.body}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
            </main>
            <FooterSix />
        </div>
    )
}

export default PrivacyPolicy

